import { computed, makeObservable } from 'mobx';

import { IFieldArray } from 'shared/entities/form';

import { FieldModel } from './FieldModel';

export class FieldArrayModel<T = string>
  extends FieldModel<T[]>
  implements IFieldArray<T>
{
  constructor(value: T[]) {
    super(value);

    this._value = [...value];
    this._initialValue = [...value];

    makeObservable<FieldArrayModel<T>>(this, {
      isInitial: computed
    });
  }

  changeValue(value: T[]): void {
    this._value = value;
    this.resetError();

    this.isInitial ? this.resetTouched() : this.setTouched();
  }

  getCopy(): FieldArrayModel<T> {
    return new FieldArrayModel<T>(this.value);
  }

  isEqual(model: FieldArrayModel<T>): boolean {
    return (
      this.value.length === model.value.length &&
      this.value.every((item) => model.value.includes(item))
    );
  }

  get isInitial(): boolean {
    if (this._value.length !== this.initialValue.length) {
      return false;
    }

    return !this._value.some((item) => !this.initialValue.includes(item));
  }

  reset(): void {
    this.resetError();
    this._value = [...this.initialValue];
    this.setTouched(false);
  }
}
